<template>
  <HeadlessMenu as="div" class="inline-block text-left">
    <HeadlessMenuButton
      ref="referenceRef"
      class="hover:bg-background-fg/3 flex h-8 w-8 items-center justify-center rounded-lg"
    >
      <IconHeroiconsSolidEllipsisVertical
        class="text-background-fg"
      />
    </HeadlessMenuButton>

    <Teleport to="body">
      <div ref="floatingRef" :style="floatingStyles">
        <Transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <HeadlessMenuItems
            class="text-background-fg bg-background z-1 mt-1 w-56 origin-top-right space-y-1 rounded-md p-1 shadow-lg ring-1 ring-black/5 focus:outline-none"
          >
            <slot />
          </HeadlessMenuItems>
        </Transition>
      </div>
    </Teleport>
  </HeadlessMenu>
</template>

<script setup lang="ts">
import {
  useFloating,
  offset,
  flip,
  autoUpdate,
} from "@floating-ui/vue"

const referenceRef = ref(null)
const floatingRef = ref(null)
const { floatingStyles } = useFloating(
  referenceRef,
  floatingRef,

  {
    placement: "bottom-end",
    strategy: "fixed",
    whileElementsMounted: autoUpdate,
    middleware: [offset(4), flip()],
  }
)
</script>
